// Extracted out of PreferencesPage.tsx so other screens (e.g. BazaarPage's location search)
// can share the same postcode/town → coordinates resolution instead of duplicating it.
export async function geocodePostcode(postcode: string): Promise<{ lat: number; lng: number }> {
  const cleaned = postcode.trim().toUpperCase();
  // Try full postcode first
  const res = await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(cleaned.replace(/\s/g, ''))}`);
  const data = await res.json();
  if (data.result?.latitude) return { lat: data.result.latitude, lng: data.result.longitude };
  // Fall back to outcode (district) lookup — handles e.g. LS1, SW10, M1
  const outcode = cleaned.split(/\s/)[0];
  const res2 = await fetch(`https://api.postcodes.io/outcodes/${encodeURIComponent(outcode)}`);
  const data2 = await res2.json();
  if (data2.result?.latitude) return { lat: data2.result.latitude, lng: data2.result.longitude };
  throw new Error('Location not found. Please select a suggestion from the dropdown.');
}

export type LocationSuggestion = { display: string; value: string; isPlace: boolean };

export async function fetchSuggestions(raw: string): Promise<LocationSuggestion[]> {
  const q = raw.trim();
  if (q.length < 2) return [];
  const isPostcodeLike = /^[A-Z]{1,2}\d/i.test(q);
  if (isPostcodeLike) {
    try {
      const r = await fetch(
        `https://api.postcodes.io/postcodes/${encodeURIComponent(q.replace(/\s/g, ''))}/autocomplete`
      );
      const d = await r.json();
      return ((d.result as string[]) ?? []).slice(0, 8).map(pc => ({
        display: pc, value: pc, isPlace: false,
      }));
    } catch { return []; }
  }
  // Place name (town/city) → map to outcode
  try {
    const r = await fetch(`https://api.postcodes.io/places?q=${encodeURIComponent(q)}&limit=8`);
    const d = await r.json();
    return ((d.result as Array<{ name_1: string; name_2?: string; outcode: string }>) ?? [])
      .map(p => ({
        display: `${p.name_1}${p.name_2 ? `, ${p.name_2}` : ''} — ${p.outcode}`,
        value: p.outcode,
        isPlace: true,
      }));
  } catch { return []; }
}
